import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Paper } from '@mui/material';
import { TableBody } from '.';
import { Pagination, SearchTable, TableHeader } from '../../TableTemplate/index';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import { applyFilter, emptyRows, getComparator, extractDate } from '../../../Utils/table';
import { selectItemMaterialData } from '../../Selectors/Master/ItemSelectors';
import { fetchItemMaterialData } from '../../../Store/PHPSlice/Item';
import TitleBar from '../../TitleBar';
import { Items } from '../../TitleList';



const ItemMaterialReg = () => {
    const dispatch = useDispatch();
    const materialData = useSelector(selectItemMaterialData);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('empId');
    const [selected, setSelected] = useState([]);
    const [filterName, setFilterName] = useState('null');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");
    const [firstIndex, setFirstIndex] = useState(0);
    const [lastIndex, setLastIndex] = useState(0);

    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [pageRange, setPageRange] = useState([0, 10]); // Initial range [0, 10]
    const [searchTerm, setSearchTerm] = useState('');
    useEffect(() => {
        dispatch(fetchItemMaterialData());
    }, [dispatch]);

    if (!materialData) {
        return <h1>Loading...</h1>;
    }


    const compData = Array.isArray(materialData.data) ? materialData.data.map((item, index) => (
        {
            id: item.ID,
            itemId: item.itemId,
            brandId: item.brandId,
            itemNm: item.itemNm,
            brandNm: item.brandNm,
            serialNumber: index + 1
        }
    )) : [];


    const handleChangeCPage = (n) => {
        setCurrentPage(n);
    };
    const handleSort = (event, id) => {
        const isAsc = orderBy === id && order === 'asc';
        if (id !== '') {
            setOrder(isAsc ? 'desc' : 'asc');
            setOrderBy(id);
        }
    };
    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = compData.map((n) => n.name);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }
        setSelected(newSelected);
    };

    const handlePrevPage = () => {
        if (currentPage !== firstIndex) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextpage = () => {
        if (currentPage !== lastIndex) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handleRecordsPerPageChange = (event) => {
        setRecordsPerPage(parseInt(event.target.value, 10)); // Parse selected value to integer
        setCurrentPage(1); // Reset current page when records per page changes
    };

    const totalCount = compData && compData.length;
    const npages = Math.ceil(totalCount / recordsPerPage);
    const numbers = Array.from({ length: npages }, (_, i) => i + 1);
    const renderPaginationButtons = () => {
        let start = Math.max(1, currentPage - 5);
        let end = Math.min(npages, start + 9);

        if (end - start < 9) {
            start = Math.max(1, end - 9);
        }

        return numbers.slice(start - 1, end).map((n) => (

            <button key={n} className={`page-link ${currentPage === n - 1 ? 'active' : ''}`} onClick={() => handleChangeCPage(n - 1)}>{n}</button>
        ));
    };

    const handleFilterByName = (event) => {
        setPage(0);
        const value = event.target.value.trim();
        setFilterName(event.target.value);

    };
    // const dataFiltered = applyFilter({
    //     inputData: compData,
    //     comparator: getComparator(order, orderBy),

    // });
    // const notFound = !dataFiltered.length;

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Reset to first page on search
    };

    const filteredData = (Array.isArray(compData) ? compData : []).filter(item =>
        item.itemNm.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.brandNm.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const dataFiltered = applyFilter({
        inputData: filteredData,
        comparator: getComparator(order, orderBy),

    });

    const totalPages = Math.ceil(dataFiltered.length / itemsPerPage);
    const displayedData = dataFiltered.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);


    const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1);
    const visiblePageNumbers = pageNumbers.slice(pageRange[0], pageRange[1]);

    const handleNextPageRange = () => {
        setPageRange([pageRange[0] + 5, pageRange[1] + 5]);
    };

    const handlePreviousPageRange = () => {
        setPageRange([pageRange[0] - 5, pageRange[1] - 5]);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(Number(event.target.value));
        setCurrentPage(1); // Reset to first page on change
    };


    return (
        <>

            <TitleBar data={Items} />
            <div style={{ margin: '2% 0%' }}>
                <h2>Material Register</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>

                            <SearchTable
                                handleItemsPerPageChange={handleItemsPerPageChange}
                                searchTerm={searchTerm}
                                handleSearchChange={handleSearchChange}
                                totalItems={filteredData?.length}
                            />


                            <TableContainer style={{ marginTop: '2%' }}>
                                <Table>
                                    <TableHeader
                                        headCells={
                                            [
                                                { id: 'serialNumber', label: 'Sr.No' },
                                                { id: 'itemNm', label: 'Item' },
                                                { id: 'brandNm', label: 'Brand' },
                                                { id: '', label: 'Material' },
                                                { id: '', label: 'Edit' },
                                                { id: '', label: 'Delete' },

                                            ]
                                        }
                                        order={order}
                                        orderBy={orderBy}
                                        onRequestSort={handleSort}
                                        numSelected={selected.length}
                                        rowCount={compData.length}
                                        onSelectAllClick={handleSelectAllClick}
                                    />
                                    <tbody>
                                        {displayedData?.map((row, index) => (
                                            <TableBody
                                                key={row.srNo}
                                                id={row.id}
                                                itemId={row.itemId}
                                                itemNm={row.itemNm}
                                                brandId={row.brandId}
                                                brandNm={row.brandNm}
                                                serialNumber={row.serialNumber}
                                                selected={selected.indexOf(row.companyName) !== -1}
                                                handleClick={(event) => handleClick(event, row.name)}
                                            />
                                        ))}
                                    </tbody>
                                </Table>
                            </TableContainer>


                            {/* <Pagination
                                currentPage={currentPage}
                                npages={npages}
                                handlePrevPage={handlePrevPage}
                                handleNextpage={handleNextpage}
                                setCurrentPage={setCurrentPage}
                                renderPaginationButtons={renderPaginationButtons}
                                totalCount={totalCount}
                            /> */}

                            <Pagination
                                currentPage={currentPage}
                                handlePageChange={handlePageChange}
                                handlePreviousPageRange={handlePreviousPageRange}
                                visiblePageNumbers={visiblePageNumbers}
                                pageNumber={pageNumbers}
                                pageRange={pageRange}
                                totalPages={totalPages}
                                handleNextPageRange={handleNextPageRange}
                            />
                        </Paper>
                    </Grid>
                </Grid>
            </div>

        </>
    );
}

export default ItemMaterialReg;
